<template>
	<svg viewBox="0 0 32 32">
		<path d="M16 0c-8.838 0-16 7.163-16 16s7.162 16 16 16c8.836 0 16-7.163 16-16s-7.163-16-16-16zM15.871 28.956c-7.137 0-12.923-5.786-12.923-12.923s5.786-12.923 12.923-12.923c7.136 0 12.923 5.786 12.923 12.923s-5.787 12.923-12.923 12.923zM19.606 16.777h-3.668v-6.193c0-0.672-0.545-1.218-1.217-1.218s-1.218 0.545-1.218 1.218v7.41c0 0.673 0.545 1.217 1.218 1.217h4.885c0.673 0 1.218-0.544 1.218-1.217 0-0.672-0.545-1.217-1.218-1.217z" />
	</svg>
</template>
